/**
 * @generated SignedSource<<b5bd403ac5a4b556ce0cf800f5d915da>>
 * @relayHash 0b068909b70e89d0a0fae8e512364ff1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c517259cfcce8a2b1078b48a4b86e4e113c339413e1ea43968406ff0da3a44f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceContentAccessRequestStatus = "APPROVE" | "DENY" | "PENDING" | "PENDING_SITE_APPROVAL" | "%future added value";
export type ConfluenceRequestAccessApprovalDecision = "APPROVE" | "DENY" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type ConfluenceUpdateContentAccessRequestInput = {
  accessRequestedAccountId: string;
  accessType: ResourceAccessType;
  approvalDecision: ConfluenceRequestAccessApprovalDecision;
  contentId: string;
  requestId: string;
};
export type useRealtimeAccessRequestsFlagsMutation$variables = {
  cloudId: string;
  updateContentAccessRequestInput: ConfluenceUpdateContentAccessRequestInput;
};
export type useRealtimeAccessRequestsFlagsMutation$data = {
  readonly confluence_updateContentAccessRequest: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly displayName?: string;
        readonly errorType: string | null | undefined;
        readonly processedRequestStatus?: ConfluenceContentAccessRequestStatus;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type useRealtimeAccessRequestsFlagsMutation = {
  response: useRealtimeAccessRequestsFlagsMutation$data;
  variables: useRealtimeAccessRequestsFlagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updateContentAccessRequestInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "updateContentAccessRequestInput",
    "variableName": "updateContentAccessRequestInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "ScalarField",
      "name": "processedRequestStatus"
    }
  ],
  "type": "ConfluenceUpdateContentAccessRequestMutationErrorExtension"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentAccessRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentAccessRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0b068909b70e89d0a0fae8e512364ff1",
    "id": "3c517259cfcce8a2b1078b48a4b86e4e113c339413e1ea43968406ff0da3a44f",
    "metadata": {},
    "name": "useRealtimeAccessRequestsFlagsMutation",
    "operationKind": "mutation",
    "text": "mutation useRealtimeAccessRequestsFlagsMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{extensions{__typename,errorType,statusCode,...on ConfluenceUpdateContentAccessRequestMutationErrorExtension{displayName,processedRequestStatus},...on BulkMutationErrorExtension{id}},message}}}"
  }
};
})();

(node as any).hash = "d69609e7d2f2caf0cf2ad975140f6131";

export default node;
